import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInventory = (props) => /* @__PURE__ */ _jsx("svg", {
	width: props.width ?? props.size ?? "1em",
	height: props.height ?? props.size ?? "1em",
	viewBox: "0 0 24 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 1600000742",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M12.0025 1C14.6992 1 16.8878 3.18861 16.8878 5.8853V7.81648C16.8878 8.36876 16.4401 8.81648 15.8878 8.81648H8.11719C7.5649 8.81648 7.11719 8.36876 7.11719 7.81648V5.8853C7.11719 3.18861 9.3058 1 12.0025 1Z",
				stroke: "currentColor",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M18.6119 11.3857C21.3085 11.3857 23.4972 13.5744 23.4972 16.271V18.2022C23.4972 18.7545 23.0494 19.2022 22.4972 19.2022H14.7266C14.1743 19.2022 13.7266 18.7545 13.7266 18.2022V16.271C13.7266 13.5744 15.9152 11.3857 18.6119 11.3857Z",
				stroke: "currentColor",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M5.3853 11.3857C8.08199 11.3857 10.2706 13.5744 10.2706 16.271V18.2022C10.2706 18.7545 9.82288 19.2022 9.2706 19.2022H1.5C0.947715 19.2022 0.5 18.7545 0.5 18.2022V16.271C0.5 13.5744 2.68861 11.3857 5.3853 11.3857Z",
				stroke: "currentColor",
				strokeMiterlimit: 10
			})
		]
	})
});
export default SvgInventory;
